import React from 'react';
import { envIsNormal } from '@/constants/constants';
import { envIsMexico } from '@/constants/constants';
import MexicoRegistrationForm from '@/features/authentication/registration/mexico/MexicoRegistrationForm';
import FastRegistrationForm from '@/features/authentication/registration/fast-registration/FastRegistrationForm';
import { useSelector } from 'react-redux';
import { selectLocale } from '@/store/selectors/commonSelectors';
import RegistrationThailandForm from '@/features/authentication/registration/thailand/RegistrationThailandForm';
import { useRestrictedMode } from '@/hooks/useRestrictedMode';

// TODO: remove this component once all registration are moved to modals
const Registration = () => {
  const locale = useSelector(selectLocale);
  const isRegistrationRemoved = useRestrictedMode();

  // Registration is removed in restricted mode — never render a registration form.
  if (isRegistrationRemoved) {
    return null;
  }

  if (envIsMexico()) {
    return <MexicoRegistrationForm />;
  } else if (envIsNormal() && locale === 'th') {
    return <RegistrationThailandForm />;
  } else {
    return <FastRegistrationForm />;
  }
};

export default Registration;
